import { useSelector } from 'react-redux';
import { cloneDeep } from 'lodash-es';
import * as S from './ExcludeSettings.styled';
import { Buttons } from 'components';
import { DeleteIcon, LockIcon } from 'assets/icons';
import {
  ChooseApplications,
  ParagraphWithTooltip,
  ImageWithFallback,
  CustomTooltip,
} from 'components';
import { subdirectory } from 'utils';
//import Tooltip from '@mui/material/Tooltip';

const ExcludeApps = ({
  onChange,
  onClear,
  value,
  sectionName = 'Exclude Applications:',
  fullWidth,
}) => {
  const showAppName = useSelector((state) => state.auth.show_app_name);

  function handleClear() {
    if (onClear) {
      onClear('excluded_apps');
      return;
    }
    onChange([]);
  }

  const deleteApp = (id) => {
    let newAdv = cloneDeep(value);
    newAdv = newAdv.filter((adv) => adv.pba_number !== id);
    onChange(newAdv);
  };

  const isSomeNotGlobal = value.some((item) => !item.isGlobal);

  return (
    <>
      {sectionName && (
        <S.TextField>
          <S.Title>{sectionName}</S.Title>
        </S.TextField>
      )}
      <S.FieldsWrap fullWidth={fullWidth}>
        <S.ActionField>
          <S.BtnWrap>
            <ChooseApplications
              selectedApplications={value}
              setSelectedApplications={onChange}
              title='Exclude Application'
            />
          </S.BtnWrap>
          {value.length > 0 && (
            <>
              <S.Line isNoButton={!isSomeNotGlobal} />
              {isSomeNotGlobal && (
                <S.BtnWrapp>
                  <Buttons.TertiaryNormal
                    id='categories_clear_all'
                    onClick={handleClear}
                    style={{ marginLeft: '16px' }}
                  >
                    Clear All
                  </Buttons.TertiaryNormal>
                </S.BtnWrapp>
              )}
              <S.Wrap>
                <S.SelectedItem>
                  {value?.map((item) => (
                    <S.Item key={item?.pba_number} height='52px' line>
                      <div
                        style={{
                          display: 'flex',
                          gap: '16px',
                          width: '95%',
                        }}
                      >
                        {showAppName && (
                          <S.ImgWrap>
                            <ImageWithFallback
                              src={`https://cdn.appnext.com/${subdirectory(item?.image_url)}/${
                                item?.image_url
                              }`}
                            />
                          </S.ImgWrap>
                        )}
                        <S.Column>
                          {/* <Tooltip
                                title={item?.pba_name}
                                placement="top-start"
                          > */}
                          <ParagraphWithTooltip
                            text={
                              showAppName ? item?.pba_name ?? '' : `ID: ${item?.pba_number ?? ''}`
                            }
                            field='campaigns'
                          />
                          {/* </Tooltip> */}
                          {showAppName && <S.Package>ID: {item?.pba_number}</S.Package>}
                        </S.Column>
                      </div>
                      {item.isGlobal ? (
                        <CustomTooltip content={<LockIcon />} text='General Exclude' />
                      ) : (
                        <S.IconWrapp onClick={() => deleteApp(item?.pba_number)}>
                          <DeleteIcon />
                        </S.IconWrapp>
                      )}
                    </S.Item>
                  ))}
                </S.SelectedItem>
              </S.Wrap>
            </>
          )}
        </S.ActionField>
      </S.FieldsWrap>
    </>
  );
};

export default ExcludeApps;
